import React, { useState } from 'react';
import { DocPageLayout } from '../components/DocPageLayout';
export function GlossaryPage() {
  const allTerms = [{
    term: '3D Secure (3DS)',
    definition: 'An authentication protocol that adds an additional verification step during online card payments. The cardholder is prompted to authenticate with their issuing bank, reducing fraud and shifting liability.'
  }, {
    term: 'Acquirer',
    definition: 'The financial institution (bank) that processes card payments on behalf of the merchant. The acquirer communicates with the card network and issuing bank to authorize and settle transactions.'
  }, {
    term: 'Authorization',
    definition: 'The process of verifying that a cardholder has sufficient funds and that the card is valid. An authorization places a hold on the funds but does not transfer money until capture.'
  }, {
    term: 'AVS (Address Verification Service)',
    definition: 'A fraud prevention tool that compares the billing address provided during a transaction with the address on file at the card issuer.'
  }, {
    term: 'Batch',
    definition: 'A collection of multiple transaction operations submitted together for processing. Batch processing is used for bulk operations like refunds, recurring charges, or settlements.'
  }, {
    term: 'BIN (Bank Identification Number)',
    definition: 'The first 6-8 digits of a card number that identify the issuing bank and card type. Used for routing transactions and fraud detection.'
  }, {
    term: 'Capture',
    definition: "The process of finalizing an authorized transaction and initiating the transfer of funds from the cardholder's account to the merchant's account."
  }, {
    term: 'Chargeback',
    definition: "A reversal of a transaction initiated by the cardholder's bank, typically due to a dispute. The merchant may be required to provide evidence that the transaction was legitimate."
  }, {
    term: 'CSC/CVV',
    definition: 'Card Security Code (also known as CVV, CVC, or CID). A 3 or 4 digit security code printed on the card used to verify the cardholder has physical possession of the card.'
  }, {
    term: 'Gateway',
    definition: 'A payment gateway is a technology service that authorizes and processes payments for merchants. It acts as an intermediary between the merchant and the payment processor/acquirer.'
  }, {
    term: 'Issuer',
    definition: "The bank or financial institution that issued the payment card to the cardholder. The issuer is responsible for authorizing transactions and managing the cardholder's account."
  }, {
    term: 'Merchant',
    definition: 'A business entity that accepts payments for goods or services. In the context of payment processing, the merchant integrates with the gateway to process customer payments.'
  }, {
    term: 'PAN (Primary Account Number)',
    definition: 'The full card number (typically 16 digits) printed or embossed on a payment card. The PAN is sensitive data that must be protected according to PCI DSS requirements.'
  }, {
    term: 'PCI DSS',
    definition: 'Payment Card Industry Data Security Standard. A set of security standards designed to ensure that all companies that accept, process, store, or transmit credit card information maintain a secure environment.'
  }, {
    term: 'Refund',
    definition: 'The return of funds to a cardholder for a previously captured transaction. Refunds can be full or partial and are processed through the original payment method.'
  }, {
    term: 'Session',
    definition: 'A temporary server-side container that securely stores payment details during the checkout process. Sessions expire after a configurable timeout period.'
  }, {
    term: 'Settlement',
    definition: "The process of transferring funds from the cardholder's bank to the merchant's bank account. Settlement typically occurs within 1-3 business days after capture."
  }, {
    term: 'Token',
    definition: 'A unique identifier that replaces sensitive card data. Tokens can be stored safely and used for future transactions without exposing the actual card number.'
  }, {
    term: 'Transaction',
    definition: 'A single payment operation such as an authorization, capture, payment, refund, or void. Each transaction has a unique identifier within an order.'
  }, {
    term: 'Void',
    definition: "The cancellation of an authorized transaction before it has been captured or settled. Voiding releases the hold on the cardholder's funds."
  }, {
    term: 'Webhook',
    definition: 'An HTTP callback that delivers real-time notifications to your server when specific events occur, such as successful payments, declines, or chargebacks.'
  }];
  const letters = [...new Set(allTerms.map(t => t.term[0].toUpperCase()))].sort();
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const filteredTerms = activeLetter ? allTerms.filter(t => t.term[0].toUpperCase() === activeLetter) : allTerms;
  return <DocPageLayout title="Glossary" description="Definitions of common payment processing and gateway terminology." data-id="element-1621">
      {/* Letter filter */}
      <div className="flex flex-wrap gap-1 mb-8 pb-4 border-b border-gray-200" data-id="element-1622">
        <button onClick={() => setActiveLetter(null)} className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${activeLetter === null ? 'bg-[#CC5500] text-white' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-1623">
          All
        </button>
        {letters.map(letter => <button key={letter} onClick={() => setActiveLetter(letter === activeLetter ? null : letter)} className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${activeLetter === letter ? 'bg-[#CC5500] text-white' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-1624">
            {letter}
          </button>)}
      </div>

      {/* Terms list */}
      <div className="space-y-0" data-id="element-1625">
        {filteredTerms.map((item, index) => <div key={index} className={`py-5 ${index !== filteredTerms.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-1626">
            <dt className="text-base font-bold text-gray-900 mb-1" data-id="element-1627">
              {item.term}
            </dt>
            <dd className="text-sm text-gray-600 leading-relaxed" data-id="element-1628">
              {item.definition}
            </dd>
          </div>)}
      </div>

      {filteredTerms.length === 0 && <p className="text-gray-500 text-center py-12" data-id="element-1629">
          No terms found for the selected letter.
        </p>}
    </DocPageLayout>;
}